/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import Cookies from 'js-cookie';
import isBTC from '~/client/hooks/currency/helpers/isBTC';
import { getSportsbetUpdateCurrencyMutation } from '../../graphql/SportsbetUpdateCurrencyMutation.generated';
import { getUpdateMyDefaultCurrencyMutation } from '../../graphql/UpdateMyDefaultCurrencyMutation.generated';
import getSiteInfo from '@/client/utils/getSiteInfo';

const useSetWalletCurrency = (
  walletCurrency: CashierCurrency,
  currency: CashierCurrency,
) => {
  const { isBridgeSite } = getSiteInfo();
  const setWalletCurrency = useCallback(async () => {
    console.log('in here oe setwalletcurrency', { walletCurrency, currency });
    if (walletCurrency === currency) {
      return;
    }
    if (isBridgeSite) {
      const id = Cookies.get('userPreferenceId');
      getSportsbetUpdateCurrencyMutation({
        input: { id, currency: currency as Currency },
      });
    } else {
      const updatedCurrency = isBTC(currency) ? 'BTC' : currency;
      getUpdateMyDefaultCurrencyMutation({ currency: updatedCurrency });
    }
  }, [currency, isBridgeSite, walletCurrency]);

  return { setWalletCurrency };
};

export default useSetWalletCurrency;
